import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getAllAdjustmentTypeSettings,
  addAdjustmentTypeSetting,
  updateAdjustmentTypeSetting,
  removeAdjustmentTypeSetting,
} from '@store/actions/adjustmentType.action'
import { AdjustmentType } from '@dataTypes/adjustmentType.type'

type AdjustmentTypeState = {
  adjustmentTypes: AdjustmentType[]
  count: number
  loading: boolean
  error: string | null
}

const initialState: AdjustmentTypeState = {
  adjustmentTypes: [],
  count: 0,
  loading: false,
  error: null,
}

const adjustmentTypeSlice = createSlice({
  name: 'adjustmentType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllAdjustmentTypeSettings.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        getAllAdjustmentTypeSettings.fulfilled,
        (
          state,
          action: PayloadAction<{
            adjustment_types: AdjustmentType[]
            count: number
          }>,
        ) => {
          state.loading = false
          state.adjustmentTypes = action.payload.adjustment_types
          state.count = action.payload.count
        },
      )
      .addCase(getAllAdjustmentTypeSettings.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      .addCase(
        addAdjustmentTypeSetting.fulfilled,
        (state, action: PayloadAction<AdjustmentType>) => {
          state.adjustmentTypes.push(action.payload)
        },
      )
      .addCase(addAdjustmentTypeSetting.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addAdjustmentTypeSetting.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      .addCase(
        updateAdjustmentTypeSetting.fulfilled,
        (state, action: PayloadAction<AdjustmentType>) => {
          const index = state.adjustmentTypes.findIndex(
            (item) =>
              item.adjustment_type_id === action.payload.adjustment_type_id,
          )
          if (index !== -1) {
            state.adjustmentTypes[index] = {
              ...state.adjustmentTypes[index],
              ...action.payload,
            }
          }
        },
      )
      .addCase(updateAdjustmentTypeSetting.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateAdjustmentTypeSetting.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      .addCase(
        removeAdjustmentTypeSetting.fulfilled,
        (state, action: PayloadAction<string>) => {
          state.adjustmentTypes = state.adjustmentTypes.filter(
            (item) => item.adjustment_type_id !== action.payload,
          )
        },
      )
      .addCase(removeAdjustmentTypeSetting.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(removeAdjustmentTypeSetting.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export default adjustmentTypeSlice.reducer
